/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import pt from 'prop-types';
import Form, { Field } from 'components/form';
import Button from 'components/button';
import Loading from 'components/loading';

export default class AppReviewCommentForm extends React.PureComponent {
  static contextTypes = {
    openModal: pt.func.isRequired,
  };

  static propTypes = {
    label: pt.string,
    topComment: pt.object,
    defaultValues: pt.object,
    canAddInternal: pt.bool,
    onSubmitComment: pt.func,
  };

  static defaultProps = {
    label: 'Write a comment',
    canAddInternal: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      values: props.defaultValues || {},
    };
  }

  onChangeComment = (values) => {
    this.setState({ values });
  };

  onSubmitComment = async (values) => {
    const { onSubmitComment } = this.props;

    this.setState({ loading: true });

    await onSubmitComment(values);

    this.setState({
      loading: false,
      values: {},
    });
  };

  render() {
    const { label, topComment, defaultValues, canAddInternal } = this.props;
    const { loading, values } = this.state;
    const { internal, comment } = values;
    const isInternal = topComment?.internal || Boolean(internal);
    const hasComment = comment?.length > 0;

    return (
      <div className="review-comments--form">
        <Form onSubmit={this.onSubmitComment} onChange={this.onChangeComment}>
          {topComment && (
            <Field type="hidden" name="top_id" value={topComment.id} />
          )}
          <Field
            type="editor"
            label={label}
            name="comment"
            placeholder="Write a comment"
            value={comment}
          />
          <div className="review-comments--form-actions">
            {canAddInternal && (
              <Field
                type="checkbox"
                label="Internal comment"
                name="internal"
                checked={isInternal}
                disabled={topComment?.internal}
              />
            )}
            <Button type="submit" size="sm" disabled={!hasComment}>
              {defaultValues ? 'Save' : topComment ? 'Reply' : 'Add comment'}
              {loading && <Loading size={14} />}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
